import classNames from 'classnames'

import { getHtmlTelLink } from '../../../../utils/link'
import Text from '../../../Text'
import {
  PROFILE_INFO_COPYABLE_FIELD_TYPES,
  QA_NAME_PROFILE_INFO_EMAIL_BUTTON,
} from '../ProfileInfoWidget.constants'
import { isInfoEmailField, isInfoPhoneField } from '../ProfileInfoWidget.utils'
import { ProfileInfoWidgetItemCopyButton } from '../ProfileInfoWidgetItemCopyButton'
import { ProfileInfoWidgetItemValue } from '../ProfileInfoWidgetItemValue'

import * as styles from './ProfileInfoWidgetItem.module.css'

function ProfileInfoWidgetItem({
  label,
  placeholder,
  type,
  value,
  onClickEmail,
}) {
  const isCopyable = value && PROFILE_INFO_COPYABLE_FIELD_TYPES.includes(type)

  const handleClickValue =
    onClickEmail && isInfoEmailField(type) ? onClickEmail : null

  return (
    <div className={styles.ProfileInfoWidgetItem}>
      <Text isSecondary>{label}</Text>
      <div
        className={classNames(styles.value, {
          [styles.valueCopyable]: isCopyable,
        })}
      >
        {value ? (
          <ProfileInfoWidgetItemValue
            qaName={QA_NAME_PROFILE_INFO_EMAIL_BUTTON}
            to={value && isInfoPhoneField(type) ? getHtmlTelLink(value) : null}
            value={value}
            onClick={handleClickValue}
          />
        ) : (
          <Text className={styles.placeholder}>{placeholder}</Text>
        )}
        {isCopyable ? (
          <ProfileInfoWidgetItemCopyButton
            className={styles.copyButton}
            type={type}
            value={value}
          />
        ) : null}
      </div>
    </div>
  )
}

export default ProfileInfoWidgetItem
